import React, { useRef, useState } from 'react';

import { ToolbarButton } from '../ToolbarButton/ToolbarButton';
import classes from './HeadingSelector.module.scss';

interface HeadingSelectorProps {
	currentHeading: string;
	onHeadingChange: (level: 1 | 2 | 3 | 4 | 5 | 6) => void;
	onParagraph: () => void;
}

export const HeadingSelector: React.FC<HeadingSelectorProps> = ({
	currentHeading,
	onHeadingChange,
	onParagraph,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null);

	const headings = [
		{ level: 1, label: 'Заголовок 1' },
		{ level: 2, label: 'Заголовок 2' },
		{ level: 3, label: 'Заголовок 3' },
		{ level: 4, label: 'Заголовок 4' },
		{ level: 5, label: 'Заголовок 5' },
		{ level: 6, label: 'Заголовок 6' },
	];

	return (
		<div className={classes.headingSelector} ref={dropdownRef}>
			<ToolbarButton
				onClick={() => setIsOpen(!isOpen)}
				title='Выбор заголовка'
				isActive={currentHeading === 'Текст' ? false : true}
			>
				<svg
					width='24px'
					height='24px'
					viewBox='0 0 24 24'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						d='M7 5V12M7 12V19M7 12H17M17 5V12M17 12V19'
						stroke='currentColor'
						strokeWidth='1.4'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>
			</ToolbarButton>

			{isOpen && (
				<div className={classes.headingDropdown}>
					{headings.map((heading) => (
						<button
							key={heading.level}
							type='button'
							data-level={heading.level}
							className={`${classes.headingOption} ${
								currentHeading === heading.label ? classes.active : ''
							}`}
							onClick={() => {
								onHeadingChange(heading.level as 1 | 2 | 3 | 4 | 5 | 6);
								setIsOpen(false);
							}}
						>
							{heading.label}
						</button>
					))}
					<button
						type='button'
						className={`${classes.headingOption} ${
							currentHeading === 'Текст' ? classes.active : ''
						}`}
						onClick={() => {
							onParagraph();
							setIsOpen(false);
						}}
					>
						Текст
					</button>
				</div>
			)}
		</div>
	);
};
